// extracted by mini-css-extract-plugin
export default {"legend":"Legend-module__legend__cb3c7f0acde2b2e44b71"};